import { render, staticRenderFns } from "./InformationType.vue?vue&type=template&id=33098ccb&"
import script from "./InformationType.vue?vue&type=script&lang=ts&"
export * from "./InformationType.vue?vue&type=script&lang=ts&"
import style0 from "./InformationType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports